import { Component } from '@angular/core';

@Component({
  selector: 'app-rgpdue-policy-entities-detail',
  templateUrl: './rgpdue-policy-entities-detail.component.html',
  styles: [
    `ul {
      padding-inline-start: 20px;
    }`
  ]
})
export class RgpduePolicyEntitiesDetailComponent { }
